import React, { useEffect, useState } from 'react'
import Header, { HeaderPhone } from './components/Header'
import Home from './components/Home'
import Work from './components/Work'
import Timeline from './components/Timeline'
import Services from './components/Services'
import Testimonial from './components/Testimonial'
import Contact from './components/Contact'
import Footer from './components/Footer.jsx'
import { Toaster } from 'react-hot-toast'
import './app.css'
import './index.js'

const App = () => {
  const [menuopen, setMenuOpen] = useState(false);


  return (
    <>
      {/* <div className='dot'></div> */}
      <HeaderPhone menuOpen={menuopen} setMenuOpen={setMenuOpen} />
      <Header menuOpen={menuopen} setMenuOpen={setMenuOpen} />
      <Home />
      <Work />
      <Timeline />
      <Services />
      <Testimonial />
      <Contact />
      <Footer />
      <Toaster />

    </>
  )
}

export default App